import { render, staticRenderFns } from "./EmpresasModal.vue?vue&type=template&id=60a5b57d"
import script from "./EmpresasModal.vue?vue&type=script&lang=js"
export * from "./EmpresasModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports